<ng-snotify></ng-snotify>

<app-login *ngIf="!isAuthed"></app-login>

<div *ngIf="isAuthed">

  <div class="nav-container">
    <div class="nav-logo-banner">
      <div style="display: flex;flex-direction: row; align-content: center; align-items: center;">

      <img src="assets/images/logo.jpg" class="logo-header" />

      <div style="width: 0%;">
        <button class="add-btn" style="min-width:0px"
          onclick="document.documentElement.setAttribute('data-theme', document.documentElement.getAttribute('data-theme') === 'light' ? 'dark' : 'light')"
          (click)="setTheme()">
          <!-- Sun Icon -->
          <svg *ngIf="_scheme == null || _scheme == 'dark'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            width="25px" height="25px">
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2v2" />
            <path d="M12 20v2" />
            <path d="m4.93 4.93 1.41 1.41" />
            <path d="m17.66 17.66 1.41 1.41" />
            <path d="M2 12h2" />
            <path d="M20 12h2" />
            <path d="m6.34 17.66-1.41 1.41" />
            <path d="m19.07 4.93-1.41 1.41" />
          </svg>
          <!-- MOON Icon -->
          <svg *ngIf="_scheme != null && _scheme == 'light'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            width="25px" height="25px">
            <path
              d="M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401" />
          </svg>
        </button>
      </div>
    </div>


    <div style="display: flex;flex-direction: column; align-content: flex-end; align-items: flex-end;">
      <div style="display: flex;flex-direction: row; align-content: center; align-items: center;">
        <a (click)="logout()">

          <div class="alt-text">
            Welcome {{firstname}} {{lastname}}
          </div>

          Logout
        </a>


      </div>
      <img src="assets/images/poweredbycoretransparentWhite.png" class="core-header" />

    </div>
  </div>


</div>
<router-outlet></router-outlet>
</div>